import React, { FC } from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { toOptionalFixed } from '@app/helpers/format';
import { formatUSD } from '@app/helpers/formatUSD';

type Props = {
  amount: number | string;
  usdAmount: number | null;
};

export const DepositSection: FC<Props> = ({ amount, usdAmount }) => {
  return (
    <VStack gap={1} alignItems="flex-start">
      <Text fontSize="14px" color="gray.4" fontWeight={500}>
        {toOptionalFixed(+amount, 2)}
      </Text>
      {usdAmount ? (
        <Text fontSize="14px" color="white">
          {formatUSD.format(usdAmount)}
        </Text>
      ) : null}
    </VStack>
  );
};
